export const PUBLIC_ASSET_PATH = `${process.env.PUBLIC_URL}/assets`
